<template>
    <div>
        <section id="header" class="l-header header-page">
            <a href="/" title="Control Panel" class="col-xs-12 col-md-4 col-lg-3 col-xl-2 l-header--logo">
                <img :src="whitelabel.LOGO" />
            </a>
            <div class="l-container l-container--full l-header--nav">
                <nav class="c-menu">
                    <ul class="c-menu__list">
                        <li class="c-menu__item">
                            <router-link :to="{ name: 'domains.index' }" class="c-menu__link" title="Domains">
                                <span class="icon-ccs icon-domains-ccs"></span>
                                <span class="c-menu__entry">Domains</span>
                            </router-link>
                        </li>

                        <li v-if="$store.getters['user/isAccountOwner']" class="c-menu__item">
                            <a class="c-menu__link" :href="$laroute.route('entities_index')" title="Servers">
                                <span class="icon-ccs icon-servers-ccs"></span>
                                <span class="c-menu__entry">Servers</span>
                            </a>
                        </li>

                        <li v-if="$store.getters['user/isAccountOwner']" class="c-menu__item">
                            <a class="c-menu__link" :href="$laroute.route('reports')" title="Reports">
                                <span class="icon-ccs icon-reports-ccs"></span>
                                <span class="c-menu__entry">Reports</span>
                            </a>
                        </li>

                        <li v-if="$store.getters['user/isReseller']" class="c-menu__item">
                            <router-link :to="{ name: 'reseller.info_page' }" class="c-menu__link" title="Account">
                                <span class="icon-ccs icon-users-light-ccs"></span>
                                <span class="c-menu__entry">Reseller</span>
                            </router-link>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="l-header--account">
                <ul class="logged-bar">
                    <li class="logged-bar__item">
                        <template v-if="$store.state.user.account_data.logged_in_as === 1">
                            Logged in as <strong>{{ $store.state.user.user_data.email }}</strong>
                            <b-button @click="$root.$children[0].logoutAsUser" variant="warning" size="sm">
                                Logout as user
                            </b-button>
                        </template>
                    </li>
                    <li class="logged-bar__item logged-bar__dropdown-parent logged-bar__item--account-details">
                        <span class="account-details">
                            <span class="icon-profile-ccs"></span>
                            <span class="icon-maximize-ccs"></span>
                        </span>
                        <div class="logged-bar__dropdown">
                            <ul class="logged-bar__dropdown--item">
                                <li>
                                    <ul>
                                        <li>
                                            <router-link :to="{ name: 'account.information' }" title="Account">
                                                <span class="client-name">{{ $store.state.user.user_data.email }}</span>
                                            </router-link>
                                        </li>
                                        <li class="client-name--wrapper">
                                            <span class="client-email">
                                                Portal Id: {{ $store.state.user.user_data.company_id }}
                                            </span>
                                        </li>
                                        <li>
                                            <router-link :to="{ name: 'account.information' }" title="Account">
                                                <span class="c-menu__entry">Account</span>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link :to="{ name: 'account.change_password' }" title="Account">
                                                <span class="c-menu__entry">Change Password</span>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link :to="{ name: 'account.2fa' }" title="Account">
                                                <span class="c-menu__entry">2FA Authentication</span>
                                            </router-link>
                                        </li>
                                        <li v-if="can_have_sub_accounts">
                                            <router-link :to="{ name: 'account.sub_accounts' }" title="Account">
                                                <span class="c-menu__entry">Sub-accounts</span>
                                            </router-link>
                                        </li>
                                    </ul>
                                </li>
                                <li v-if="$store.getters['user/isAccountOwner']">
                                    <ul>
                                        <li>
                                            <a :href="whitelabel.BILLING_URL" title="Billing Area">Billing Area</a>
                                        </li>
                                        <li>
                                            <a :href="whitelabel.SUPPORT_URL" title="Tickets & Support"
                                                >Tickets & Support</a
                                            >
                                        </li>
                                    </ul>
                                </li>
                                <li class="logged-bar__item">
                                    <a href="#" @click="$root.$children[0].logout" title="Logout">Logout</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="mobile-menu--toggle">
                <label for="mobileTrigger"
                    ><span class="wl-menu"
                        ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                            <path
                                d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                            /></svg></span
                ></label>
            </div>
        </section>
        <slot></slot>
    </div>
</template>
<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState({
            whitelabel: "whitelabel"
        }),
        can_have_sub_accounts: function() {
            if (this.$store.state.user.account_data.account_type) {
                if (
                    this.$store.state.user.account_data.account_type !==
                    this.$store.state.user.ACCOUNT_TYPES.CCS_USER_TYPE_DOMAINS_ACCOUNT
                ) {
                    return true;
                }
            }

            return false;
        }
    },

    mounted() {
        // this Layout loads if user is logged in
        // on GuestLayout the "body--guest" class is added to body, so let's remove it once we are in this Layout
        this.$nextTick(() => {
            document.body.classList.remove("body--guest");
        });
    }
};
</script>
<style scoped>
.l-container {
    max-width: 66.6%;
}
</style>
